export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_25f231ada2fcf825bbb0e8d0